import { memo, useContext, useEffect, useMemo, useState } from "react";

import appStyles from "../../../App.module.css";
import { BusinessTravelContext } from "../../BusinessTravel";
import { showPartnerLogoAndText, showPartnerLogoAndTextNote } from "../../config/bt-constants";
import { IBusinessTravelContext } from "../../config/interfaces";
import QuoteApi from "../api/QuoteApi";

const BTHeader = () => {
  const { currentStep, quoteData, version } = useContext(BusinessTravelContext) as IBusinessTravelContext;
  const [partnerLogo, setPartnerLogo] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const hideLogo = useMemo(() => {
    return showPartnerLogoAndText(quoteData?.affiliateId, version);
  }, [version, quoteData.affiliateId]);

  // getting Partner logo on the basis of partner id
  useEffect(() => {
    const getPartnerLogo = async () => {
      try {
        if (!hideLogo) {
          return;
        }
        const partnerResponse = await QuoteApi.getPartnerLogo(quoteData.affiliateId);
        if (partnerResponse.errors) {
          setPartnerLogo(null);
          return;
        }
        setPartnerLogo(partnerResponse?.data?.logo_path);
      } catch (error) {
        setPartnerLogo(null);
      } finally {
        setLoading(false);
      }
    };

    getPartnerLogo();
  }, [quoteData.affiliateId]);
  return (
    <>
      {!loading && (
        <div
          className={` ${appStyles.MY20} ${
            partnerLogo
              ? [`${appStyles.footerLogosWrap} ${currentStep === 0 ? appStyles.btW576 : appStyles.btW1200}`]
              : appStyles.footerLogosWrapper
          } `}
        >
          {partnerLogo ? (
            <>
              <div
                className={`${appStyles.partnerLogoWrapper} ${appStyles.partnerLogoImgWrap} ${
                  showPartnerLogoAndTextNote.includes(quoteData.affiliateId) ? appStyles.widePartnerLogo : null
                }`}
              >
                <img src={partnerLogo} alt="Partner Logo" />
              </div>
              {!showPartnerLogoAndTextNote.includes(quoteData.affiliateId) ? (
                <div className={`${appStyles.poweredbyLogoWrapper} ${appStyles.poweredByBorderLeft}`} />
              ) : null}
            </>
          ) : (
            <div className={appStyles.BattleFaceBGLogo}></div>
          )}
        </div>
      )}
    </>
  );
};

export default memo(BTHeader);
